import React, { useState, useEffect } from "react";
import {
  setStartDate,
  setEndDate,
  runQueryPagoda,
  REQUEST_STARTED,
} from "../../../redux/action";
import { RootState } from "../../../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import moment from "moment";
import _ from "lodash";
import CommonTable from "../../../components/Table/CommonTable";
import { getComparisonSummary, dataComparator } from "../../kayJwellers/helper";
import CustomDateRangePicker from "../../kayJwellers/KJTabs/CustomDateRangePicker";
import { PagodaEventTypes } from "../events.config";
import { downloadCSV } from "../../kayJwellers/helper";
import { getSkuData, installationData } from "../../../common/api";
import { useDispatch } from "react-redux";
import { Button, Checkbox, FormControl, Grid, Input, InputLabel, ListItemText, MenuItem, Select, Theme, Typography } from "@mui/material";
import useClasses from "../../../common/UseClasses";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from "dayjs";

const headers: any = [
  { label: "Event Name", key: "event_name" },
  { label: "Event Count", key: "value" },
  { label: "% Change", key: "change" },
];

type PropsFromRedux = ConnectedProps<typeof connector>;
type SummaryTabProps = PropsFromRedux & {};

const PagodaSummaryTab: React.FC<SummaryTabProps> = ({
  startDateObj,
  endDateObj,
  setStartDate,
  setEndDate,
  runQueryPagoda,
  dateRange,
  ...rest
}) => {

const useStyles = (theme: Theme) => ({
      formControl: {
        marginRight:10,
        marginLeft: 20,
        minWidth: 300,
        // margin: theme.spacing(1),
        maxWidth: 300,
      },
      selectEmpty: {
        marginTop: theme.spacing(0),
      },
      checkbox: {
        display: "block",
        paddingLeft: 5,
      },
      indeterminateColor: {
        color: "#f50057",
      },
      selectAllText: {
        fontWeight: 500,
      },
      selectedAll: {
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.08)",
        },
      },
    })

  const MenuProps = {
    PaperProps: {
      style: {
        width: "100vw",
        height: "100vh",
      },
    },
  };

  const dispatch = useDispatch();

  // const classes = useStyles();
  const classes: any = useClasses(useStyles);

  const [eventByName, setEventByName] = useState(undefined);

  const [totalStoreCount, setTotalStoreCount] = useState(0);

  const [Stores, setStores] = useState([]);

  const [storeList, setStoreList] = React.useState<string[]>([]);

  // const [storeList, setStoreList]= useState([
  //   "ABC", "XYZ", "PQR"])

  const isAllSelected = Stores.length > 0 && storeList.length === Stores.length;

  const handleChange = (event:any) => {
    //setStoreList(event.target.value as string[]);
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setStoreList(storeList.length === Stores.length ? [] : Stores);
      return;
    }
    setStoreList(value);
  };

  const getCSVData = () => {
    if (eventByName) {
      const data: any = eventByName;
      return data.tableRow;
    } else {
      return [];
    }
  };

  useEffect(() => {
      getAllStores();
  }, []);

  const getAllStores = async () => {
    let installationdata: any[];

    installationData().then((res) => (installationdata = res?.data));
    const stores: any = [...storeList];

    const query = `SELECT param.value.string_value AS storeName,param1.value.string_value AS store_id
      FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
      UNNEST(event_params) AS param,UNNEST(event_params) AS param1 WHERE (param.key = 'vv_store_name') AND (param1.key = 'vv_store_id')
      group by 1,2 `;

    let storesResult: any = await runQueryPagoda({ query }, false);
    if (storesResult.length > 0) {
      storesResult.forEach((resultItem: any) => {
        installationdata.forEach((dataItem: any) => {
          if (resultItem.store_id === dataItem.store_id) {
            resultItem.installation_date = dataItem.installation_date;
          }
        });
      });
      storesResult = storesResult.sort((a: any, b: any) => {
        if (a.installation_date === undefined) {
          return 1;
        }
        if (b.installation_date === undefined) {
          return -1;
        }
        if (a.installation_date && b.installation_date) {
          const newA = a.installation_date.split("/").reverse().join("-");
          const newB = b.installation_date.split("/").reverse().join("-");
          return +new Date(newA) - +new Date(newB);
        }
      });
      storesResult.forEach((element: any) => {
        stores.push(element.storeName);
      });
      setStores(stores);
      setStoreList(stores);
      setTotalStoreCount(stores.length);
    }
  };

  const getSelectedAPIList = async (storename: any[] = []) => {

    console.log("PAGODA CALL .......")
    /* function to fire BIG Query 
                            fetch data and format data according to table format */
    let installationdata: any[];
    installationData().then((res) => (installationdata = res?.data));
    const stores: any = [...storeList];

    setTotalStoreCount(stores?.length);

    let tableData: any = {
      tableHeader: [
        { label: "Event Name", key: "event_name" },
        { label: "Event Count", key: "value" },
        { label: "% Change", key: "change" },
      ],
      tableRow: [],
    };

    const startDate1 = moment(dateRange.selection1.startDate).format(
      "YYYYMMDD"
    ); // converts startdate of 1st date range
    const endDate1 = moment(dateRange.selection1.endDate).format("YYYYMMDD"); // converts enddate of 1st date range

    const startDate2 = moment(dateRange.selection2.startDate).format(
      "YYYYMMDD"
    ); // converts startdate of 2nd date range
    const endDate2 = moment(dateRange.selection2.endDate).format("YYYYMMDD"); // converts enddate of 2nd date range

    let storeNameStr = ``;
    //storename ? storeNameStr = `and param.value.string_value = '${storename}' ` : storeNameStr = ``; /* storename parameter exists in call inject into query */
    if (storeList.length > 0) {
      storeNameStr = `and (param.value.string_value = '${storeList[0]}' `;
      for (let i = 1; i < storeList.length; i++) {
        storeNameStr =
          storeNameStr + `or param.value.string_value = '${storeList[i]}' `;
      }

      storeNameStr = storeNameStr + ")";
    }

    let query = `SELECT event_name, count(1) as value 
    FROM \`pagoda-cms-prod.analytics_211897923.events_*\`, 
    UNNEST(event_params) AS param WHERE (param.key = 'vv_store_name' ) ${storeNameStr}
    AND event_date >= '${startDate1}' AND  event_date <= '${endDate1}'  
    group by 1 order by value desc`; // Query for 1st Date Range

    const startDateRangeResult: any = await runQueryPagoda({ query }, false);

    query = `SELECT event_name, count(1) as value 
                          FROM \`pagoda-cms-prod.analytics_211897923.events_*\`, 
                          UNNEST(event_params) AS param WHERE (param.key = 'vv_store_name' ) ${storeNameStr}
                          AND event_date >= '${startDate2}' AND  event_date <= '${endDate2}'  
                          group by 1 order by value desc`; //Query for 2nd Date Range

    const endDateRangeResult: any = await runQueryPagoda({ query }, false);
    const data = getComparisonSummary(
      startDateRangeResult,
      endDateRangeResult,
      PagodaEventTypes
    ); // call to helper function to get Data sorted according to events config

    // --------------- Added new product value with producusku and price calculations
    query = `SELECT param2.value.string_value AS screen_name , param1.value.string_value as product_sku, count(1) AS value
        FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
        UNNEST(event_params) AS param1,
        UNNEST(event_params) AS param,
        UNNEST(event_params) AS param2
        WHERE (param1.key = 'vv_product_sku' and param2.key = 'vv_screen_name') AND
              (event_name = 'vv_product_select_ab_test' or event_name = 'vv_product_select' or event_name = 'vv_product_select_banter') 
              AND (param.key = 'vv_store_name') ${storeNameStr}  AND event_date >= '${startDate1}'
              AND  event_date <= '${endDate1}'
              group by 1,2 order by value desc`;

    const strtDttotalValRangeResult: any = await runQueryPagoda(
      { query },
      false
    );

    query = `SELECT param2.value.string_value AS screen_name , param1.value.string_value as product_sku, count(1) AS value
        FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
        UNNEST(event_params) AS param1,
        UNNEST(event_params) AS param,
        UNNEST(event_params) AS param2
        WHERE (param1.key = 'vv_product_sku' and param2.key = 'vv_screen_name')
            AND (event_name = 'vv_product_select_ab_test' or event_name = 'vv_product_select' or event_name = 'vv_product_select_banter')
            AND (param.key = 'vv_store_name') ${storeNameStr}  AND event_date >= '${startDate2}'
            AND  event_date <= '${endDate2}'
              group by 1,2 order by value desc`;

    const endDttotalValRangeResult: any = await runQueryPagoda(
      { query },
      false
    );

    const productName = "pagoda";
    const header = {
      "Content-Type": "application/json",
      "Api-Key": "a304d7bf-4c28-4bfb-a387-2408c2c2de6f",
      "Client-ID": "bb872ca6-7b27-4300-b5a6-5b188712fc16",
    };
    let count = 0;
    const processStartData = strtDttotalValRangeResult.map(
      async (data: any) => {
        dispatch({ type: REQUEST_STARTED });
        let product_sku = data["product_sku"];
        let value = data["value"];

        const obj: any = {};
        obj.value = 0;
        obj.event_name = data["event_name"];
        const productdata: any = await getSkuData(
          product_sku,
          header,
          productName
        );
        if (
          productdata &&
          productdata.product &&
          productdata.product.price &&
          value
        ) {
          // obj.priceValue= (productdata.product.price * obj.value).toFixed(2);
          const calculatedStartDateVal = (
            productdata.product.price * value
          ).toFixed(2);
          obj.value = Number(calculatedStartDateVal);
        }

        return obj;
      }
    );
    const AllData = Promise.all(processStartData)
      .then((data) => data)
      .catch((error) =>
        console.log(
          "Error in start date while product total value data gathering..",
          error
        )
      );

    const strtDateProductValArr: any = (await AllData) || [];

    const processEndDateData = endDttotalValRangeResult.map(
      async (data: any) => {
        let product_sku = data["product_sku"];
        count += 1;
        let value = data["value"];

        const obj: any = {};
        obj.value = 0;
        obj.event_name = data["event_name"];

        const productdata: any = await getSkuData(
          product_sku,
          header,
          productName
        );
        if (
          productdata &&
          productdata.product &&
          productdata.product.price &&
          value
        ) {
          // obj.priceValue= (productdata.product.price * value).toFixed(2);
          const calculatedVal = (productdata.product.price * value).toFixed(2);
          obj.value = Number(calculatedVal);
        }
        return obj;
      }
    );
    const AllEndDateData = Promise.all(processEndDateData)
      .then((data) => data)
      .catch((error) =>
        console.log(
          "Error in end date while product total value data gathering..",
          error
        )
      );

    let endDateProductValArr: any = (await AllEndDateData) || [];

    const { start, end } = data; //splitting data and the stores into different variable

    if (storeList.length === 0) {
      const query = `SELECT param.value.string_value AS storeName,param1.value.string_value AS store_id
      FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
      UNNEST(event_params) AS param,UNNEST(event_params) AS param1 WHERE (param.key = 'vv_store_name') AND (param1.key = 'vv_store_id')
      group by 1,2 `;

      let storesResult: any = await runQueryPagoda({ query }, false);
      storesResult.forEach((resultItem: any) => {
        installationdata.forEach((dataItem: any) => {
          if (resultItem.store_id === dataItem.store_id) {
            resultItem.installation_date = dataItem.installation_date;
          }
        });
      });
      storesResult = storesResult.sort((a: any, b: any) => {
        if (a.installation_date === undefined) {
          return 1;
        }
        if (b.installation_date === undefined) {
          return -1;
        }
        const newA = a.installation_date.split("/").reverse().join("-");
        const newB = b.installation_date.split("/").reverse().join("-");
        return +new Date(newA) - +new Date(newB);
      });
      storesResult.forEach((element: any) => {
        stores.push(element.storeName);
      });
      setStores(stores);
      setStoreList(stores);
      setTotalStoreCount(stores.length);
    }

    if (start) {
      //calculate average session per day and per store for 1st Date Range
      const eventobj = start.find(
        (eventtype: any) => eventtype["event_name"] === "Total User Sessions"
      );
      if (eventobj) {
        const totalSessionSum = eventobj["value"];

        const sumObj = {
          event_name: "Average Number of Sessions Per Store",
          value: (totalSessionSum / stores.length).toFixed(
            2
          ) /* calculate average sessions  per store using total user session/ total store count */,
        };
        start.push(sumObj);
        const diff = moment
          .duration(moment(endDate1).diff(moment(startDate1)))
          .asDays();
        const daysObj = {
          event_name: "Average Number of Sessions Per Day",
          value: (diff / stores.length).toFixed(
            2
          ) /* calculate average session per day using total user sessions / no of days selected */,
        };
        start.push(daysObj);
        query = `SELECT SUM(CAST(param1.value.string_value AS DECIMAL)) as value ,count(param1.value.string_value) as session_count
        FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
        UNNEST(event_params) AS param1,UNNEST(event_params) AS param
        WHERE (param.key = 'vv_store_name') ${storeNameStr}
        AND (param1.key = 'vv_session_duration_time_in_secs_string')
        AND event_name = "vv_user_session_end_banter" 
        AND event_date >= '${startDate1}' AND event_date <= '${endDate1}'`;

        const totalSessionTimeStartDate: any = await runQueryPagoda(
          { query },
          false
        );

        let AvgSessiontime: String;

        if (totalSessionTimeStartDate[0]["value"] === null) {
          AvgSessiontime = "N/A";
        } else {
          let sumOfSessions = totalSessionTimeStartDate[0]["value"];
          let sessionCount = totalSessionTimeStartDate[0]["session_count"];
          AvgSessiontime = (sumOfSessions / sessionCount).toFixed(2);
        }

        const sessionObj = {
          event_name: "Average Session Time",
          value: AvgSessiontime,
        };
        start.push(sessionObj);
      }

      query = `SELECT count(1) AS value FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,UNNEST(event_params) AS param, UNNEST(event_params) AS param2, UNNEST(event_params) AS param3 WHERE param.key = 'vv_store_name' ${storeNameStr} and param2.key = 'vv_screen_name' and event_name = 'vv_product_select' AND (param2.value.string_value = 'catalog' OR param2.value.string_value = 'catalog_banter') AND event_date >= '${startDate1}' AND event_date <= '${endDate1}' `;

      const startDateRangeResultforCategory: any = await runQueryPagoda(
        { query },
        false
      );

      query = `SELECT count(1) AS value
    FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
    UNNEST(event_params) AS param, UNNEST(event_params) AS param2, UNNEST(event_params) AS param3
    WHERE param.key = 'vv_store_name' ${storeNameStr} and param2.key = 'vv_screen_name' and event_name = 'vv_product_select' AND (param2.value.string_value = 'vto' OR param2.value.string_value = 'vto_banter') AND event_date >= '${startDate1}' AND event_date <= '${endDate1}' `;

      const startDateRangeResultforVto: any = await runQueryPagoda(
        { query },
        false
      );

      const catagoryObj = {
        event_name: "Total Product Views for Category Screen",
        value:
          startDateRangeResultforCategory &&
          startDateRangeResultforCategory.length
            ? startDateRangeResultforCategory[0]["value"]
            : 0 /* count for screen_name is category or category_banter */,
      };

      start.push(catagoryObj);
      const vtoObj = {
        event_name: "Total Product Views for VTO Screen",
        value:
          startDateRangeResultforVto && startDateRangeResultforVto.length
            ? startDateRangeResultforVto[0]["value"]
            : 0 /* count for screen_name is category or category_banter */,
      };
      start.push(vtoObj);

      // product view value with productsku and price*val calculation
      const sumAll = strtDateProductValArr
        .map((item: { value: Number }) => item.value)
        .reduce((prev: number, curr: number) => prev + curr, 0);

      const formatNo = sumAll.toLocaleString("en-US");

      const totalVal = {
        event_name: "Total Product View Value",
        value: `$${formatNo}`,
      }; /* Total Product View Value new changes  */

      start.push(totalVal);
    }
    if (end) {
      //calculate average session per day and per store for 2nd Date Range
      const eventobj = end.find(
        (eventtype: any) => eventtype["event_name"] === "Total User Sessions"
      );

      if (eventobj) {
        const totalSessionSum = eventobj["value"];
        const sumObj = {
          event_name: "Average Number of Sessions Per Store",
          value: (totalSessionSum / stores.length).toFixed(
            2
          ) /* calculate average sessions  per store using total user session/ total store count */,
        };

        end.push(sumObj);

        const diff = moment
          .duration(moment(endDate2).diff(moment(startDate2)))
          .asDays();
        const daysObj = {
          event_name: "Average Number of Sessions Per Day",
          value: (diff / stores.length).toFixed(
            2
          ) /* calculate average session per day using total user sessions / no of days selected */,
        };
        end.push(daysObj);

        query = `SELECT SUM(CAST(param1.value.string_value AS DECIMAL)) as value ,count(param1.value.string_value) as session_count
      FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
      UNNEST(event_params) AS param1,UNNEST(event_params) AS param
      WHERE (param.key = 'vv_store_name') ${storeNameStr}
      AND (param1.key = 'vv_session_duration_time_in_secs_string')
      AND event_name = "vv_user_session_end"
      AND event_date >= '${startDate2}' AND event_date <= '${endDate2}'`; //Query for 2nd Date Range

        const totalSessionTimeEndDate: any = await runQueryPagoda(
          { query },
          false
        );

        let AvgSessiontime: String;

        if (totalSessionTimeEndDate[0]["value"] === null) {
          AvgSessiontime = "N/A";
        } else {
          let sumOfSessions = totalSessionTimeEndDate[0]["value"];
          let sessionCount = totalSessionTimeEndDate[0]["session_count"];
          AvgSessiontime = (sumOfSessions / sessionCount).toFixed(2);
        }

        const sessionObj = {
          event_name: "Average Session Time",
          value: AvgSessiontime,
        };

        end.push(sessionObj);
      }

      // product view value with productsku and price*val calculation
      const sumEndDateRangeData = endDateProductValArr
        .map((item: { value: Number }) => item.value)
        .reduce((prev: number, curr: number) => prev + curr, 0);
      const totalVal = {
        event_name: "Total Product View Value",
        value: sumEndDateRangeData,
      }; /* Total Product View Value new changes  */

      end.push(totalVal);

      query = `SELECT count(1) AS value
    FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
    UNNEST(event_params) AS param, UNNEST(event_params) AS param2, UNNEST(event_params) AS param3
    WHERE param.key = 'vv_store_name' ${storeNameStr} and param2.key = 'vv_screen_name' and event_name = 'vv_product_select' AND (param2.value.string_value = 'catalog' OR param2.value.string_value = 'catalog_banter') AND event_date >= '${startDate2}' AND event_date <= '${endDate2}' `;

      const endDateRangeResultForCategory: any = await runQueryPagoda(
        { query },
        false
      );

      query = `SELECT count(1) AS value
    FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
    UNNEST(event_params) AS param, UNNEST(event_params) AS param2, UNNEST(event_params) AS param3
    WHERE param.key = 'vv_store_name' ${storeNameStr} and param2.key = 'vv_screen_name' and event_name = 'vv_product_select' AND (param2.value.string_value = 'vto' OR param2.value.string_value = 'vto_banter') AND event_date >= '${startDate2}' AND event_date <= '${endDate2}' `;

      const endDateRangeResultForVto: any = await runQueryPagoda(
        { query },
        false
      );
      const catagoryObj = {
        event_name: "Total Product Views for Category Screen",
        value:
          endDateRangeResultForCategory && endDateRangeResultForCategory.length
            ? endDateRangeResultForCategory[0]["value"]
            : 0 /* count for screen_name is category or category_banter */,
      };

      end.push(catagoryObj);
      const vtoObj = {
        event_name: "Total Product Views for VTO Screen",
        value:
          endDateRangeResultForVto && endDateRangeResultForVto.length
            ? endDateRangeResultForVto[0]["value"]
            : 0 /* count for screen_name is category or category_banter */,
      };
      end.push(vtoObj);
    }

    const compareData = dataComparator(start, end); //call to helper function to get Compared Data in percentage

    tableData.tableRow.push(...compareData);

    setEventByName(
      tableData
     ); /*update state variable for table data to render */
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", marginTop: 30 }}>
        <CustomDateRangePicker />
{/* 
        <LocalizationProvider dateAdapter={AdapterDayjs}>
<DatePicker
label="From Date"
format="MM/DD/YYYY"
value={dayjs(startDateObj)}
sx={{marginRight:'10px'}}
// onChange={handleFromDateChange}
/>

<DatePicker
label="From Date"
format="MM/DD/YYYY"
value={dayjs(endDateObj)}
sx={{marginRight:'10px'}}
// onChange={handleToDateChange}
/>

    </LocalizationProvider> */}


        <FormControl sx={classes.formControl}>
          <InputLabel id="demo-mutiple-checkbox-label">All Stores</InputLabel>
          <Select
            labelId="demo-mutiple-checkbox-label"
            id="demo-mutiple-checkbox"
            multiple
            value={storeList}
            onChange={handleChange}
            input={<Input />}
            renderValue={(selected) => (selected as string[]).join(", ")}
            MenuProps={MenuProps}
            sx={classes.selectEmpty}
          >
            <MenuItem
              value="all"
              sx={{
                root: isAllSelected ? classes.selectedAll : "",
              }}
            >
              <Checkbox
                checked={isAllSelected}
                sx={{ indeterminate: classes.indeterminateColor }}
                indeterminate={
                  storeList.length > 0 && storeList.length < Stores.length
                }
              />
              <ListItemText primary="All Stores" />
            </MenuItem>
            {Stores &&
              Stores.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox checked={storeList.indexOf(name) > -1} />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <div style={{display:"flex",marginLeft:"5px" }}>
        <Button
        sx={{
          width: 150,
          height:40,
          marginRight:2
        }}
          variant="contained"
          color="secondary"
          onClick={() => {
            getSelectedAPIList(storeList);
          }}
        >
          Apply
        </Button>
        <div style={{margin:"0px 5px"}}>
          <Button
          color="primary"
          sx={{
            height:40,
            width:200,
            color: "white",
            textDecorationLine: "none",
            fontSize: 12,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
            variant="contained" 
            onClick={() => downloadCSV(getCSVData(), "Summary", headers)}
          >
            {" "}
            Download CSV
          </Button>
        </div>
        </div>
      </div>

      <div style={{ display: "flex", marginTop: 20, marginBottom: 10 }}>
        <Typography sx={{ fontSize: 18 }} color="primary">Total Store Count : </Typography>
        <Typography sx={{ fontSize: 18, fontWeight: 800, marginLeft: 18 }} color="primary">
          {totalStoreCount ? totalStoreCount : "--"}
        </Typography>
      </div>

      {eventByName ? (
        <Grid container spacing={4}>
          <Grid item md={12} xs={6} lg={6}>
            <CommonTable tableData={eventByName} />
          </Grid>
        </Grid>
      ) : null}
    </div>
  );
};

const mapState = (state: RootState) => ({
  isUserLoggedIn: state.user.isUserLoggedIn,
  startDateObj: state.report.startDate,
  endDateObj: state.report.endDate,
  dateRange: state.report.dateRange,
});

const connector = connect(mapState, {
  setStartDate,
  setEndDate,
  runQueryPagoda,
});

export default connector(PagodaSummaryTab);
